import React, { useEffect } from 'react';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { Screen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import WebView, { WebViewNavigation } from '@/components/Webview';
import { Box } from '@/components/lib/components';
import { KycStackScreenProps } from '@/navigation/kyc/types';
import { requestCameraPermissionIfNotGranted } from '@/utils/camera';
import { isWeb } from '@/utils/constants-platform-specific';

import { isIdpvReturnUrl } from './utils';

type ScreenProps = KycStackScreenProps<'KycIdpvWebView'>;

// IDPV - ID Photo Verification
export const IdpvWebView = ({ navigation, route }: ScreenProps) => {
    const { uri } = route?.params;

    useEffect(() => {
        requestCameraPermissionIfNotGranted();
    }, []);

    // IDComply redirects to the Betr website when the IDPV is done (completed or closed)
    const handleShouldStartLoad = ({ url }: WebViewNavigation) => {
        if (!isIdpvReturnUrl(url)) {
            return true;
        }
        navigation.navigate('KycVerifyingIdpv');
        return false;
    };

    // Redirect to the IDPV URL if the app is running on the web
    if (isWeb && uri) {
        window.location.href = uri;
        return null;
    }

    return (
        <Screen>
            <ScreenNavBar title={'Upload your ID'} closeIconMode="back" />
            <WebView
                source={{ uri }}
                allowsInlineMediaPlayback
                mediaPlaybackRequiresUserAction={false}
                startInLoadingState
                onShouldStartLoadWithRequest={handleShouldStartLoad}
                renderLoading={() => (
                    <Box alignItems="center" justifyContent="center" height="100%">
                        <LoadingSpinner />
                    </Box>
                )}
            />
        </Screen>
    );
};
